<template>
  <v-btn
    block
    large
    depressed
    :height="height"
    :color="color"
    :class="classes"
    class="rounded-4"
    :disabled="disabled || loading"
    @click="execute"
  >
    {{ loading ? loadingText : buttonText }}
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="grey"
      size="21"
      width="2"
      class="ml-2"
    ></v-progress-circular>
  </v-btn>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    buttonText: {
      type: String,
      required: true,
    },
    loadingText: {
      type: String,
      required: true,
    },
    callFn: {
      type: Function,
      required: true,
    },
    classes: {
      type: Array,
      default() {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '52',
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async execute() {
      if (this.loading) {
        return
      }

      try {
        this.loading = true

        await this.callFn()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

button:disabled,
.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: $gray-fill !important;
  color: $white !important;
}

.basic-button {
  line-height: 1.4;
}
</style>
